import React, { useState } from 'react';
import { Tabs, Tab, Box, Typography } from '@mui/material';
import MachineGroup from '../Machinegroup/machinegroup';
import ReasonGroup from '../Reasongroup/reasongroup';
import ProcessGroup from '../Processgroup/processgroup';
import PlantGroup from '../Plantgroup/plantgroup';
import { cleanCustomerId, isPmiCustomer } from '../../Services/app/operatorservice';
import { useUserRole } from '../../Shared/hooks/useUserRole';

const GroupRegistration = () => {
  const customerId = localStorage.getItem('CustomerID');
  const { isSuperAdmin } = useUserRole();
  const showPlantTab = isPmiCustomer(customerId) && isSuperAdmin;
  const [tabValue, setTabValue] = useState(showPlantTab ? 0 : 1);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <div className="pages">
      <div className="pagecontents">
        {/* --- Tabs Header --- */}
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            textColor="inherit"
            TabIndicatorProps={{ sx: { backgroundColor: '#f47803' } }} aria-label="group registration tabs"
          >
            {showPlantTab && <Tab label="Plant Groups" value={0} />}
            <Tab label="Machine Group" value={1} />
            <Tab label="Reason Group" value={2} />
            {cleanCustomerId(customerId) === window._env_.GPLAST_CUSTOMER_ID && (

              <Tab label="Process Group" value={3} />)}
          </Tabs>
        </Box>

        {/* --- Tab Panels --- */}
        {showPlantTab && (
          <TabPanel value={tabValue} index={0}>
            <PlantGroup IsInGroupReg />
          </TabPanel>
        )}

        <TabPanel value={tabValue} index={1}>
          <MachineGroup IsInGroupReg />
        </TabPanel>

        <TabPanel value={tabValue} index={2}>
          <ReasonGroup IsInGroupReg />
        </TabPanel>
        {cleanCustomerId(customerId) === window._env_.GPLAST_CUSTOMER_ID && (

          <TabPanel value={tabValue} index={3}>
            <ProcessGroup IsInGroupReg />
          </TabPanel>)}
      </div>
    </div>
  );
};

/** Helper Component for Tab Panels **/
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 1 }}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

export default GroupRegistration;
